import { Card, CardContent } from '../ui/card';
import { CalendarDays, Clock, Phone, Mail } from 'lucide-react';

const STATUS_COLORS = {
  pending: 'bg-yellow-100 text-yellow-700',
  confirmed: 'bg-green-100 text-green-700',
  completed: 'bg-gray-100 text-gray-600',
  cancelled: 'bg-red-100 text-red-700',
};

const STATUS_OPTIONS = ['pending', 'confirmed', 'completed', 'cancelled'];

export const AppointmentsList = ({ appointments, onUpdateStatus }) => (
  <div className="space-y-4" data-testid="admin-appointments-list">
    {appointments.length === 0 ? (
      <Card className="border-none shadow-md">
        <CardContent className="p-8 text-center text-gray-500">No appointments booked yet.</CardContent>
      </Card>
    ) : (
      appointments.map((a) => (
        <Card key={a.id} className="border-none shadow-md hover:shadow-lg transition-all">
          <CardContent className="p-5">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2 flex-wrap">
                  <h3 className="text-lg font-bold text-darkBrown">{a.name}</h3>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_COLORS[a.status] || STATUS_COLORS.pending}`}>
                    {a.status}
                  </span>
                  <span className="text-xs text-gray-400">#{a.confirmationCode}</span>
                </div>
                <p className="text-sm text-darkBrown font-medium flex items-center gap-4 flex-wrap">
                  <span className="flex items-center gap-1"><CalendarDays size={14} className="text-primaryOrange" /> {a.dateLabel}</span>
                  <span className="flex items-center gap-1"><Clock size={14} className="text-primaryOrange" /> {a.timeLabel}</span>
                </p>
                <p className="text-sm text-gray-600 mt-1">{a.visitTypeLabel}</p>
                <p className="text-sm text-gray-600 mt-1 flex items-center gap-4 flex-wrap">
                  <span className="flex items-center gap-1"><Mail size={14} /> {a.email}</span>
                  <span className="flex items-center gap-1"><Phone size={14} /> {a.phone}</span>
                </p>
                {a.reason && <p className="text-gray-700 mt-2 text-sm">{a.reason}</p>}
              </div>
              <div className="flex-shrink-0">
                <select
                  value={a.status}
                  onChange={(e) => onUpdateStatus('appointments', a.id, e.target.value)}
                  className="text-sm border rounded-md px-3 py-1.5"
                  data-testid={`admin-appointment-status-${a.id}`}
                >
                  {STATUS_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>
          </CardContent>
        </Card>
      ))
    )}
  </div>
);
